import React, { Component } from "react";
import SelectCreate from 'react-select/creatable';
import dayjs from "dayjs";

import { auth } from "../../utils/auth";
import { apiUrl } from "../../utils/apiUrl";
import { toast } from "../../utils/helpers";
import { postRequest, withRequest } from "../../utils/request";
import Modal from "../general/Modal";

class Edit extends Component {
    state = {
        fecha: '',
        monto: '',
        descuentosPendientes: '',
        errors: {},
        descuento: {},
        showDelete: false,
    };
    editDescuento = async (event) => {
        event.preventDefault();

        const data = new FormData(event.target);
        const response = await postRequest(
            apiUrl(`descuentos/${this.props.descuentoId}`),
            data
        );

        if (response.success) {
            this.props.getDescuentos();
            this.props.toggle();
        }

        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }
    };
    deleteDescuento = async (descuento) => {


        const url = `descuentos/${descuento}`;

        const response = await postRequest(apiUrl(url), {}, 'delete');



        if (response.success) {
            this.props.getDescuentos();
            this.props.toggle();
            toast("Descuento borrado.");
            return;
        } else {
            toast(response.data, "error");
        }
    };
    toggleDeleteModal = () => {
        this.setState({
            showDelete: !this.state.showDelete,
        });
    };
    render() {
        const { errors } = this.state;
        const { toggle, descuento, columnas, descuentoId } = this.props;

        return (
            <div>
                <form method='post' onSubmit={this.editDescuento}>
                    <input type='hidden' name='_method' value='patch' />
                    <div className='popup__header'>Editar Descuento</div>
                    <div className="popup__body">
                        <div className='row form-group'>
                            <div className='col col-md-4'>
                                <label className='label form-control-label'>
                                    Monto:
                                </label>
                            </div>
                            <div className='col col-md-8'>
                                <input type="hidden" name="monto" value={descuento.monto} />
                                <input
                                    type='number'
                                    name='monto_total'
                                    step="0.01"
                                    defaultValue={descuento.montoTotal}
                                    className='form-control'
                                />
                                {errors.monto && (
                                    <small className='help-blockParams form-Text'>
                                        {errors.monto[0]}
                                    </small>
                                )}
                            </div>
                        </div>
                        <div className='row form-group'>
                            <div className='col col-md-4'>
                                <label className='label form-control-label'>
                                    Fecha:
                                </label>
                            </div>
                            <div className='col col-md-8'>
                                <input
                                    type='date'
                                    name='fecha'
                                    defaultValue={dayjs(descuento.fecha).format('YYYY-MM-DD')}
                                    className='form-control'
                                />
                                {errors.fecha && (
                                    <small className='help-blockParams form-Text'>
                                        {errors.fecha[0]}
                                    </small>
                                )}
                            </div>
                        </div>
                        {descuento.frecuencia === 'Unico' && <div className='row form-group'>
                            <div className='col col-md-4'>
                                <label className='label form-control-label'>
                                    Estado:
                                </label>
                            </div>
                            <div className='col col-md-8'>
                                <select
                                    name='cuotas_pendientes'
                                    defaultValue={descuento.pendientes > 0 ? 1 : 0}
                                    className='form-control'
                                >
                                    <option value="1">Pendiente</option>
                                    <option value="0">Pagada</option>
                                </select>
                                {errors.cuotas_pendientes && (
                                    <small className='help-blockParams form-Text'>
                                        {errors.cuotas_pendientes[0]}
                                    </small>
                                )}
                            </div>
                        </div>}
                        <div className='row form-group'>
                            <div className='col col-md-4'>
                                <label className='label form-control-label'>
                                    Columna Nómina:
                                </label>
                            </div>
                            <div className='col col-md-8'>
                                <SelectCreate
                                    defaultValue={descuento.columna ? {label: descuento.columna?.nombre, value: descuento.columna?.id} : null}
                                    options={columnas.map(c => ({value: c.id, label: c.nombre}))}
                                    name="columna_nomina"
                                />
                            </div>
                        </div>
                        <div className='row form-group'>
                            <div className='col col-md-4'>
                                <label className='label form-control-label'>
                                    Descripción:
                                </label>
                            </div>
                            <div className='col col-md-8'>
                                <textarea
                                    name='descripcion'
                                    defaultValue={descuento.descripcion}
                                    className='form-control'
                                />
                                {errors.descripcion && (
                                    <small className='help-blockParams form-Text'>
                                        {errors.descripcion[0]}
                                    </small>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className='popup__footer'>
                        <button
                            type='button'
                            className='btn float-left'
                            onClick={this.toggleDeleteModal}>
                            <i className='fas fa-trash-alt'></i>
                        </button>
                        <button
                            type='button'
                            onClick={toggle}
                            className='btn btn-plain'>
                            Cancelar
                        </button>
                        <button type='submit' className='btn btn-primary'>
                            Guardar
                        </button>
                    </div>
                </form>
                <Modal
                    title='Borrar Descuento'
                    show={this.state.showDelete}
                    callback={() => this.deleteDescuento(descuentoId)}
                    acceptText='Borrar'
                    toggle={this.toggleDeleteModal}>
                    ¿Estás seguro de que deseas borrar este descuento?
                </Modal>
            </div>
        );
    }
}

export default withRequest(Edit);
